import styled from "@emotion/styled";
import { breakpoints, spacing } from "@atlas-int/tokens";
import { RouteID } from "../../routing/routes";
import Card from "./Card";
import { googleAnalyticsCustomEvent } from "../../sharedUtilities/analytics";
import ExploreImage from "./img/explore.png";
import CountryProfilesImage from "./img/country_profiles.png";
import GrowthImage from "./img/annual_growth.png";
import RankingImage from "./img/ranking.png";

const OuterContainer = styled.div`
  grid-column: span 3;
  width: 100%;
  padding: 0 ${spacing[10]};
  box-sizing: border-box;

  @media (min-width: ${breakpoints.lg}) {
    padding: 0 100px;
  }
`;

const CardGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1200px;
  width: 100%;
  margin: 4rem auto 2.5rem;
  gap: 3rem 5rem;

  @media (max-width: ${breakpoints.lg}) {
    gap: 3rem;
  }

  @media (max-width: ${breakpoints.sm}) {
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
  }
`;

const IntroCards = () => {
  return (
    <OuterContainer>
      <CardGrid>
        <Card
          title="Trade Dynamics & Growth Opportunities"
          body="Build custom data visualizations to reveal 50+ years of global trade flows and opportunities for growth."
          ctaText="Start Exploring"
          ctaDestination={RouteID.TreeMap}
          imageUrl={ExploreImage}
          showAward={false}
          href="/explore/treemap"
          analyticsEvent={() => {
            googleAnalyticsCustomEvent("card", "click", "explore", "home");
          }}
        />
        <Card
          title="Country Profiles"
          body="An interactive journey through a country's economic structure and growth patterns to uncover strategies for greater prosperity."
          ctaText="Start Exploring"
          ctaDestination={RouteID.CountryProfiles}
          imageUrl={CountryProfilesImage}
          showAward={true}
          href="/countries"
          analyticsEvent={() => {
            googleAnalyticsCustomEvent("card", "click", "cp", "home");
          }}
        />
        <Card
          title="Annual Growth Projections"
          body="Discover the countries rising and falling in Harvard Growth Lab's annual country growth projections."
          ctaText="Start Exploring"
          ctaDestination={RouteID.GrowthProjections}
          imageUrl={GrowthImage}
          showAward={false}
          href="/press-release"
          analyticsEvent={() => {
            googleAnalyticsCustomEvent("card", "click", "gp", "home");
          }}
        />
        <Card
          title="Complexity Rankings"
          body="Explore Harvard Growth Lab's annual ranking of country and product complexity."
          ctaText="Start Exploring"
          ctaDestination={RouteID.CountryRankings}
          imageUrl={RankingImage}
          showAward={false}
          href="/rankings"
          analyticsEvent={() => {
            googleAnalyticsCustomEvent("card", "click", "complexity", "home");
          }}
        />
      </CardGrid>
    </OuterContainer>
  );
};

export default IntroCards;
